import Bioma from "../../../../models/Bioma";
import Especie from "../../../../models/Especie";
import Patrocinador from "../../../../models/Patrocinador";
import Apoiador from "../../../../models/Apoiador";

/**
 * Cadastros de conteúdo do painel (o que aparece no app). Cada um tem uma página
 * de lista (/admin/conteudo/:recurso) e páginas de formulário (/novo e
 * /:id/editar). Os textos concentrados aqui evitam concordância errada
 * ("Espécie salvo") espalhada pelas telas.
 *
 * `resumo`: chave em /relatorios/resumo -> plataforma, para a contagem do cartão.
 */
export const RECURSOS = {
  biomas: {
    id: "biomas", model: Bioma, resumo: "biomas",
    titulo: "Biomas", singular: "bioma",
    descricao: "Biomas em que as espécies ocorrem.",
    adicionar: "Adicionar bioma", novo: "Novo bioma", editar: "Editar bioma",
    salvo: "Bioma salvo.", excluido: "Bioma excluído.",
    busca: { texto: "Buscar bioma", placeholder: "Digite o nome do bioma" },
    vazio: "Nenhum bioma cadastrado.",
  },
  especies: {
    id: "especies", model: Especie, resumo: "especies",
    titulo: "Espécies", singular: "espécie",
    descricao: "Espécies que podem ser escolhidas ao registrar um plantio.",
    adicionar: "Adicionar espécie", novo: "Nova espécie", editar: "Editar espécie",
    salvo: "Espécie salva.", excluido: "Espécie excluída.",
    busca: { texto: "Buscar espécie", placeholder: "Nome comum ou científico" },
    vazio: "Nenhuma espécie cadastrada.",
    porPagina: 20,
  },
  banners: {
    id: "banners", model: Patrocinador, resumo: "patrocinadores",
    titulo: "Banners", singular: "banner",
    descricao: "Banners de patrocinadores exibidos no site e no app.",
    adicionar: "Adicionar banner", novo: "Novo banner", editar: "Editar banner",
    salvo: "Banner salvo.", excluido: "Banner excluído.",
    busca: { texto: "Buscar banner", placeholder: "Nome ou link do patrocinador" },
    vazio: "Nenhum banner cadastrado.",
  },
  apoiadores: {
    id: "apoiadores", model: Apoiador, resumo: "apoiadores",
    titulo: "Apoiadores", singular: "apoiador",
    descricao: "Pessoas e empresas que apoiam o projeto. Quem pede pelo app aparece com os dados do próprio perfil; os pedidos ficam em Pedidos.",
    // Cadastro à mão é a exceção (empresa ou pessoa sem conta no app): o caminho
    // normal é o pedido feito pelo app e aprovado em Pedidos.
    adicionar: "Adicionar apoiador manualmente", novo: "Novo apoiador (cadastro manual)", editar: "Editar apoiador",
    explicacaoNovo: "Use para empresas ou pessoas que não têm conta no app. Quem tem conta pede pelo app e você aprova em Pedidos.",
    atalho: { rotulo: "Ver pedidos de apoio →", para: "/admin/pedidos?tipo=apoiador" },
    salvo: "Apoiador salvo.", excluido: "Apoiador removido.",
    busca: { texto: "Buscar apoiador", placeholder: "Nome ou link do apoiador" },
    vazio: "Nenhum apoiador cadastrado.",
  },
};

export const ORDEM = ["biomas", "especies", "banners", "apoiadores"];

export const caminhoLista = (recurso) => `/admin/conteudo/${recurso}`;
export const caminhoNovo = (recurso) => `/admin/conteudo/${recurso}/novo`;
export const caminhoEditar = (recurso, id) => `/admin/conteudo/${recurso}/${id}/editar`;
